import { Component, NgZone, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState, AuthActionTypes } from '@app/core/ngrx';
import { Router } from '@angular/router';
import { MSALAuthService } from '@app/auth/msal-auth.service';
@Component({
  selector: 'ecp-login-header-form',
  templateUrl: './login-header-form.component.html',
  styleUrls: ['./login-header-form.component.scss'],
  standalone: false,
})
export class LoginHeaderFormComponent implements OnInit {
  loginForm: UntypedFormGroup;

  // @select(['auth', 'error'])
  error$: Observable<any>;

  // @select(['auth', 'pending'])
  pending$: Observable<boolean>;

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private store: Store<AppState>,
    private authService: MSALAuthService,
  ) {}

  ngOnInit(): void {
    this.error$ = this.store.pipe(select((state) => state.auth.error));
    this.pending$ = this.store.pipe(select((state) => state.auth.pending));
    this.loginForm = this.createForm();
  }

  get username(): AbstractControl {
    return this.loginForm.get('username');
  }

  get password(): AbstractControl {
    return this.loginForm.get('password');
  }

  createForm(): UntypedFormGroup {
    const username = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.email]),
    });

    const password = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.minLength(1)]),
    });

    return new UntypedFormGroup({ username, password }, { updateOn: 'submit' });
  }

  onLogin(): void {
    this.authService.login();
  }
}
